import { getCurrentUserFromStore } from '@lastbrand/fe-common/universal-auth'

const isBrowser = typeof window !== `undefined`

const getCurrentUser = () => isBrowser && (getCurrentUserFromStore() ?? {})

export default getCurrentUser
